module.exports = __webpack_public_path__ + "static/img/3_7_1.d72d5d20.jpg";